import * as actions from './actions';
import { unsubscribeRequest } from './tracking';

export default function() {
  return next => action => {
    switch (action.type) {
      case actions.UNSUBSCRIBE_ADDRESS_REQUEST:
        unsubscribeRequest(action.address);
        break;
    }
    return next(action);
  };
}
